export default "__VITE_ASSET__4z_KQO3o__"